import { createRpcMutation } from './factory'

export const useUpdateOrganization = createRpcMutation({
   fn: 'update_organization',
   successKey: 'info.organization-updated',
   invalidates: (props) => [['organization', { id: props.p_organization_id }]],
})
